import { defineMessages } from 'react-intl.macro';

import { SERVICE_ORDER_STATE } from '../constants';

export const serviceOrderMessages = defineMessages({
  listPageTitle: {
    id: 'serviceOrder.list.title',
    defaultMessage: 'Přehled žádostí bez exportu',
  },
  stateWaiting: {
    id: 'serviceOrder.list.stateWaiting',
    defaultMessage: 'Načítám žádosti - Čekejte prosím...',
  },
  stateFail: {
    id: 'serviceOrder.list.stateFail',
    defaultMessage: 'Načtení žádostí selhalo. Zkuste to prosím později.',
  },
  stateEmpty: {
    id: 'serviceOrder.list.stateEmpty',
    defaultMessage: 'Zatím tu není žádná žádost bez exportu.',
  },
  stateFilteredEmpty: {
    id: 'serviceOrder.list.stateFilteredEmpty',
    defaultMessage: 'Zadanému filtru neodpovídá žádná žádost.',
  },
  created: {
    id: 'serviceOrder.attribute.created',
    defaultMessage: 'Založeno',
  },
  confirmed: {
    id: 'serviceOrder.attribute.confirmed',
    defaultMessage: 'Potvrzeno',
  },
  paid: {
    id: 'serviceOrder.attribute.paid',
    defaultMessage: 'Zaplaceno',
  },
  documentNumber: {
    id: 'serviceOrder.attribute.documentNumber',
    defaultMessage: 'Číslo dokladu',
  },
  name: {
    id: 'serviceOrder.attribute.name',
    defaultMessage: 'Název žádosti',
  },
  priceListItem: {
    id: 'serviceOrder.attribute.priceListItem',
    defaultMessage: 'Položka ceníku',
  },
  quantity: {
    id: 'serviceOrder.attribute.quantity',
    defaultMessage: 'Počet jednotek',
  },
  items: {
    id: 'serviceOrder.attribute.items',
    defaultMessage: 'Položky',
  },
  area: {
    id: 'serviceOrder.attribute.area',
    defaultMessage: 'Plocha',
  },
  hectareUnit: {
    id: 'serviceOrder.hectareUnit',
    defaultMessage: 'ha',
  },
  note: {
    id: 'serviceOrder.attribute.note',
    defaultMessage: 'Poznámka',
  },
  zadatel: {
    id: 'serviceOrder.attribute.zadatel',
    defaultMessage: 'Žadatel',
  },
  odberatel: {
    id: 'serviceOrder.attribute.odberatel',
    defaultMessage: 'Odběratel',
  },
  creator: {
    id: 'serviceOrder.attribute.creator',
    defaultMessage: 'Zadavatel',
  },
  state: {
    id: 'serviceOrder.attribute.state',
    defaultMessage: 'Stav',
  },
  taxableSupplyDate: {
    id: 'serviceOrder.attribute.taxableSupplyDate',
    defaultMessage: 'Datum uskutečnění zdanitelného plnění',
  },
  totalGross: {
    id: 'serviceOrder.attribute.totalGross',
    defaultMessage: 'Cena celkem',
  },
  unitPriceRow: {
    id: 'serviceOrder.unitPriceRow',
    defaultMessage: '{quantity, number} × {unitPrice, number, ::currency/CZK}',
  },
  dataOrder: {
    id: 'serviceOrder.attribute.dataOrder',
    defaultMessage: 'Objednávka dat',
  },
  dataOrderNumber: {
    id: 'serviceOrder.dataOrderNumber',
    defaultMessage: 'Objednávka č. {id}',
  },
  dataOrderNumberWithName: {
    id: 'serviceOrder.dataOrderNumberWithName',
    defaultMessage: 'Objednávka č. {id} – {name}',
  },
});

export const serviceOrderStateMessages = defineMessages<SERVICE_ORDER_STATE>({
  [SERVICE_ORDER_STATE.DRAFT]: {
    id: 'enum.SERVICE_ORDER_STATE.DRAFT',
    defaultMessage: 'Rozpracovaná',
  },
  [SERVICE_ORDER_STATE.CREATED]: {
    id: 'enum.SERVICE_ORDER_STATE.CREATED',
    defaultMessage: 'Potvrzená',
  },
  [SERVICE_ORDER_STATE.PAID]: {
    id: 'enum.SERVICE_ORDER_STATE.PAID',
    defaultMessage: 'Zaplacená',
  },
});

export const serviceOrderFormMessages = defineMessages({
  detailsTitle: {
    id: 'serviceOrder.form.detailsTitle',
    defaultMessage: 'Údaje žádosti',
  },
  newTitle: {
    id: 'serviceOrder.form.newTitle',
    defaultMessage: 'Nová žádost bez exportu',
  },
  userPlaceholder: {
    id: 'serviceOrder.form.userPlaceholder',
    defaultMessage: 'Začněte psát jméno, firmu nebo IČO…',
  },
  nameHint: {
    id: 'serviceOrder.form.nameHint',
    defaultMessage:
      'Nevyplněný název se doplní podle první položky. Změnit ho můžete až do potvrzení.',
  },
  nameEditHint: {
    id: 'serviceOrder.form.nameEditHint',
    defaultMessage: 'Název můžete změnit až do potvrzení.',
  },
  nameError: {
    id: 'serviceOrder.form.nameError',
    defaultMessage: 'Vyplňte název žádosti.',
  },
  priceListItemError: {
    id: 'serviceOrder.form.priceListItemError',
    defaultMessage: 'Vyberte položku ceníku z nabídky.',
  },
  quantityError: {
    id: 'serviceOrder.form.quantityError',
    defaultMessage: 'Zadejte počet jednotek větší než nula.',
  },
  areaError: {
    id: 'serviceOrder.form.areaError',
    defaultMessage: 'Zadejte plochu v hektarech větší než nula.',
  },
  documentItemName: {
    id: 'serviceOrder.form.documentItemName',
    defaultMessage: 'Název na dokladu',
  },
  linkDataOrder: {
    id: 'serviceOrder.form.linkDataOrder',
    defaultMessage: 'Převzít plochu z objednávky dat',
  },
  dataOrderPlaceholder: {
    id: 'serviceOrder.form.dataOrderPlaceholder',
    defaultMessage: 'Číslo objednávky nebo jméno odběratele',
  },
  dataOrderHint: {
    id: 'serviceOrder.form.dataOrderHint',
    defaultMessage: 'Nabízí se jen vydané objednávky s manipulačním poplatkem.',
  },
  dataOrderError: {
    id: 'serviceOrder.form.dataOrderError',
    defaultMessage: 'Vyberte objednávku dat z nabídky.',
  },
  userError: {
    id: 'serviceOrder.form.userError',
    defaultMessage: 'Vyberte uživatele z nabídky.',
  },
  noteHint: {
    id: 'serviceOrder.form.noteHint',
    defaultMessage:
      'Tiskne se na všech dokladech pod „Celkem k úhradě“, například číslo objednávky nebo číslo jednací.',
  },
  noteSubmitSuccess: {
    id: 'serviceOrder.form.noteSubmitSuccess',
    defaultMessage: 'Poznámka byla uložena, doklady se vystavily znovu pod stejným číslem.',
  },
  priceListLoadFail: {
    id: 'serviceOrder.form.priceListLoadFail',
    defaultMessage: 'Načtení položek ceníku selhalo. Zkuste to prosím později.',
  },
  queryStateWaiting: {
    id: 'serviceOrder.form.queryStateWaiting',
    defaultMessage: 'Čekejte prosím...',
  },
  loadFail: {
    id: 'serviceOrder.form.loadFail',
    defaultMessage: 'Načtení žádosti selhalo. Zkuste to prosím později.',
  },
  submitFail: {
    id: 'serviceOrder.form.submitFail',
    defaultMessage: 'Uložení žádosti selhalo. Zkuste to prosím znovu.',
  },
  submitSuccess: {
    id: 'serviceOrder.form.submitSuccess',
    defaultMessage: 'Žádost byla uložena.',
  },
});

export const serviceOrderBtnMessages = defineMessages({
  create: {
    id: 'serviceOrder.btn.create',
    defaultMessage: 'Vytvořit žádost',
  },
  save: {
    id: 'serviceOrder.btn.save',
    defaultMessage: 'Uložit změny',
  },
  saveNote: {
    id: 'serviceOrder.btn.saveNote',
    defaultMessage: 'Uložit poznámku',
  },
  clear: {
    id: 'serviceOrder.btn.clear',
    defaultMessage: 'Vyčistit',
  },
  confirm: {
    id: 'serviceOrder.btn.confirm',
    defaultMessage: 'Potvrdit žádost',
  },
  paid: {
    id: 'serviceOrder.btn.paid',
    defaultMessage: 'Zaplaceno',
  },
  filter: {
    id: 'serviceOrder.btn.filter',
    defaultMessage: 'Filtr žádostí',
  },
  filterSubmit: {
    id: 'serviceOrder.btn.filterSubmit',
    defaultMessage: 'Filtrovat',
  },
  addItem: {
    id: 'serviceOrder.btn.addItem',
    defaultMessage: 'Přidat položku',
  },
  removeItem: {
    id: 'serviceOrder.btn.removeItem',
    defaultMessage: 'Odebrat položku',
  },
  cancel: {
    id: 'serviceOrder.btn.cancel',
    defaultMessage: 'Zrušit',
  },
});

export const serviceOrderDetailMessages = defineMessages({
  title: {
    id: 'serviceOrder.detail.title',
    defaultMessage: '{id, select, empty {Žádost bez exportu} other {Žádost č. {id}}}',
  },
  draftInfo: {
    id: 'serviceOrder.detail.draftInfo',
    defaultMessage:
      'Žádost je rozpracovaná. Zkontrolujte cenu a potvrzením ji uzavřete — tím se cena zmrazí a vznikne podklad pro fakturu.',
  },
  confirmedInfo: {
    id: 'serviceOrder.detail.confirmedInfo',
    defaultMessage:
      'Žádost čeká na zaplacení. Daňový doklad vznikne až po označení jako zaplacená.',
  },
  notDraft: {
    id: 'serviceOrder.detail.notDraft',
    defaultMessage:
      'Žádost mezitím někdo potvrdil, změny se neuložily. Upravit už lze jen poznámku.',
  },
  noteLocked: {
    id: 'serviceOrder.detail.noteLocked',
    defaultMessage: 'Žádost je mezitím zaplacená, poznámku už nelze změnit.',
  },
  confirmFail: {
    id: 'serviceOrder.detail.confirmFail',
    defaultMessage: 'Potvrzení žádosti selhalo. Zkuste to prosím znovu.',
  },
  confirmUnsaved: {
    id: 'serviceOrder.detail.confirmUnsaved',
    defaultMessage: 'Nejdřív uložte změny žádosti.',
  },
  priceChanged: {
    id: 'serviceOrder.detail.priceChanged',
    defaultMessage:
      'Ceník se mezitím změnil, cena žádosti je nyní {price, number, ::currency/CZK}. Zkontrolujte ji a potvrzení zopakujte.',
  },
  partyIncomplete: {
    id: 'serviceOrder.detail.partyIncomplete',
    defaultMessage:
      'Doklad nelze vystavit, protože chybí údaje o žadateli nebo odběrateli. Doplňte je v profilu uživatele a potvrzení zopakujte.',
  },
  confirmTitle: {
    id: 'serviceOrder.detail.confirmTitle',
    defaultMessage: 'Potvrdit žádost',
  },
  confirmDialogInfo: {
    id: 'serviceOrder.detail.confirmDialogInfo',
    defaultMessage:
      'Máte uložené všechny změny? Potvrzením se cena zmrazí a žádost už nepůjde upravit.',
  },
  paidTitle: {
    id: 'serviceOrder.detail.paidTitle',
    defaultMessage: 'Označit žádost jako zaplacenou',
  },
  paidDialogInfo: {
    id: 'serviceOrder.detail.paidDialogInfo',
    defaultMessage:
      'Potvrzením se vygeneruje daňový doklad se stejnými částkami jako podklad pro fakturu.',
  },
  paidFail: {
    id: 'serviceOrder.detail.paidFail',
    defaultMessage: 'Označení žádosti jako zaplacená selhalo. Zkuste to prosím znovu.',
  },
  taxableSupplyDateError: {
    id: 'serviceOrder.detail.taxableSupplyDateError',
    defaultMessage: 'Vyplňte datum uskutečnění zdanitelného plnění.',
  },
  taxableSupplyDateFutureError: {
    id: 'serviceOrder.detail.taxableSupplyDateFutureError',
    defaultMessage: 'Datum uskutečnění zdanitelného plnění nesmí být v budoucnosti.',
  },
  priceTitle: {
    id: 'serviceOrder.detail.priceTitle',
    defaultMessage: 'Cena',
  },
  attachmentsUploadFailed: {
    id: 'serviceOrder.detail.attachmentsUploadFailed',
    defaultMessage:
      'Žádost je založená, ale tyto soubory se nepodařilo nahrát: {names}. Nahrajte je prosím znovu v sekci Přílohy.',
  },
  partiesTitle: {
    id: 'serviceOrder.detail.partiesTitle',
    defaultMessage: 'Odběratel a žadatel',
  },
});
